import { flow } from 'fp-ts/function';
import { createScopedReducer, createScopedSelector } from '@mews/framework';
import { moduleSelector, prefix } from '../module';

export const NAME = 'associateBill';

export const SET_ASSOCIATE_BILL_DIALOG_BILL_OWNER_ID = prefix('SET_ASSOCIATE_BILL_DIALOG_BILL_OWNER_ID');

interface InitialState {
    billId: string | null;
}

const initialState: InitialState = {
    billId: null,
};

export const changeBillAssociatedAccountReducer = createScopedReducer(initialState, {
    [SET_ASSOCIATE_BILL_DIALOG_BILL_OWNER_ID]: (state: InitialState, billId: string) => ({
        ...state,
        billId,
    }),
});

const parentSelector = flow(moduleSelector, (state) => state?.[NAME]);

const getScope = createScopedSelector({ parentSelector, initialState });

export const getChangeBillAssociatedAccountDialogBillId = flow(getScope, (state) => state?.billId);
